import React from "react";
import { Outlet } from "react-router-dom";
import Splash from "./splash";
import SignInUp from "./sign-in-up";
import { useAuth } from "../hooks/use-auth";

export const ProtectedRoute = () => {
  const user = useAuth();

  if (typeof user === "undefined") return <Splash />;
  return user ? <Outlet /> : <SignInUp />;
};

export default ProtectedRoute;
